"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Modal = require("../../../Layout/Modal");
var _Button = require("../../../UI/Button");
var _useUnitData2 = require("../hooks/useUnitData");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _useItem2 = require("../hooks/useItem");
var _TaskManager2 = _interopRequireDefault(require("../TaskManager.styles"));
var _errorImg_rtl = _interopRequireDefault(require("../resources/errorImg_rtl.png"));
var _errorImg_ltr = _interopRequireDefault(require("../resources/errorImg_ltr.png"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Error = function Error(props) {
  var handleClose = props.handleClose,
    taskID = props.taskID,
    itemID = props.itemID,
    itemLanguage = props.itemLanguage,
    environmentID = props.environmentID,
    audienceID = props.audienceID,
    kotarParams = props.kotarParams,
    minDate = props.minDate,
    maxDate = props.maxDate,
    isChangeAudienceAfterSubmitEnabled = props.isChangeAudienceAfterSubmitEnabled,
    isLearningActivity = props.isLearningActivity;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    getLabel = _useContext.getLabel,
    taskError = _useContext.taskError,
    setTaskError = _useContext.setTaskError,
    isUnitDataError = _useContext.isUnitDataError,
    isCloneItemError = _useContext.isCloneItemError,
    setIsCloneItemError = _useContext.setIsCloneItemError,
    isSaveItemError = _useContext.isSaveItemError,
    setIsSaveItemError = _useContext.setIsSaveItemError,
    task = _useContext.task;
  var _useContext2 = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    siteKey = _useContext2.siteKey,
    _useContext2$directio = _useContext2.direction,
    direction = _useContext2$directio === void 0 ? 'rtl' : _useContext2$directio;
  var _useItem = (0, _useItem2.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity),
    getItem = _useItem.getItem;
  var _useUnitData = (0, _useUnitData2.useUnitData)(),
    initUnitData = _useUnitData.initUnitData;
  var styles = (0, _TaskManager2.default)();
  var errorImg = {
    rtl: _errorImg_rtl.default,
    ltr: _errorImg_ltr.default
  };
  var handleGoBack = function handleGoBack() {
    if (isUnitDataError) {
      initUnitData();
    }
    if (taskError) {
      if (task !== null && task !== void 0 && task.item) {
        setTaskError(false);
      } else if (taskID && siteKey || itemID && itemLanguage) {
        getItem();
      } else {
        setTaskError(false);
      }
    }
    if (isCloneItemError) {
      setIsCloneItemError(false);
    }
    if (isSaveItemError) {
      setIsSaveItemError(false);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      messageIcon: "BrokenHeart",
      messageType: "alert",
      message: taskError === 'is not authorized' ? getLabel('isNotAuthorized_error_title') : isUnitDataError || taskError ? getLabel('loadData_error_title') : isCloneItemError ? getLabel('cloneItem_error_title') : isSaveItemError ? getLabel('saveItem_error_title') : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TaskManager__error'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: taskError === 'is not authorized' ? getLabel('isNotAuthorized_error_sub_title') : isUnitDataError || taskError ? getLabel('loadData_error_sub_title') : isCloneItemError ? getLabel('cloneItem_error_sub_title') : isSaveItemError ? getLabel('saveItem_error_sub_title') : ''
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TaskManager__error__image-wrapper'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: errorImg[direction],
            alt: "Error",
            className: styles['cc-TaskManager__error__image']
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: taskError === 'is not authorized' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "outlined",
          onClick: handleClose,
          children: getLabel('close')
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "outlined",
          onClick: handleGoBack,
          children: getLabel('back')
        })
      })
    })]
  });
};
exports.Error = Error;